var map = {
	"./Auth/Login": 2033,
	"./Auth/Login.vue": 2033,
	"./Categories/Create": 217,
	"./Categories/Create.vue": 217,
	"./Categories/Edit": 4879,
	"./Categories/Edit.vue": 4879,
	"./Categories/Form": 387,
	"./Categories/Form.vue": 387,
	"./Categories/Index": 2894,
	"./Categories/Index.vue": 2894,
	"./Dashboard/Index": 8803,
	"./Dashboard/Index.vue": 8803,
	"./Dashboard/WorkplaceOrders": 3986,
	"./Dashboard/WorkplaceOrders.vue": 3986,
	"./Dashboard/Workplaces": 9267,
	"./Dashboard/Workplaces.vue": 9267,
	"./Kams/Create": 8652,
	"./Kams/Create.vue": 8652,
	"./Kams/Edit": 3287,
	"./Kams/Edit.vue": 3287,
	"./Kams/Index": 4256,
	"./Kams/Index.vue": 4256,
	"./Orders/Index": 6928,
	"./Orders/Index.vue": 6928,
	"./Orders/Show": 4328,
	"./Orders/Show.vue": 4328,
	"./Products/Create": 8070,
	"./Products/Create.vue": 8070,
	"./Products/Edit": 3868,
	"./Products/Edit.vue": 3868,
	"./Products/Form": 6851,
	"./Products/Form.vue": 6851,
	"./Products/Index": 9530,
	"./Products/Index.vue": 9530,
	"./Reminders/Create": 2724,
	"./Reminders/Create.vue": 2724,
	"./Reminders/Edit": 3284,
	"./Reminders/Edit.vue": 3284,
	"./Reminders/Index": 9954,
	"./Reminders/Index.vue": 9954,
	"./Reminders/Partials/LinksWithClicksTable": 6160,
	"./Reminders/Partials/LinksWithClicksTable.vue": 6160,
	"./Reminders/Partials/OpenedMailTable": 4891,
	"./Reminders/Partials/OpenedMailTable.vue": 4891,
	"./Reminders/Partials/SortChevron": 5260,
	"./Reminders/Partials/SortChevron.vue": 5260,
	"./Reminders/Preview": 6223,
	"./Reminders/Preview.vue": 6223,
	"./Reminders/ReminderForm": 114,
	"./Reminders/ReminderForm.vue": 114,
	"./Reminders/ResubscribeToOrderReminders": 7225,
	"./Reminders/ResubscribeToOrderReminders.vue": 7225,
	"./Reminders/Statistics": 845,
	"./Reminders/Statistics.vue": 845,
	"./Reminders/UnsubscribeFromOrderReminders": 3569,
	"./Reminders/UnsubscribeFromOrderReminders.vue": 3569,
	"./Reports/Index": 3824,
	"./Reports/Index.vue": 3824,
	"./Shop/Categories": 1617,
	"./Shop/Categories.vue": 1617,
	"./Shop/Checkout": 9492,
	"./Shop/Checkout.vue": 9492,
	"./Shop/Iframe": 837,
	"./Shop/Iframe.vue": 837,
	"./Shop/Index": 5266,
	"./Shop/Index.vue": 5266,
	"./Shop/Product": 1331,
	"./Shop/Product.vue": 1331,
	"./Shop/Products": 2974,
	"./Shop/Products.vue": 2974,
	"./Shop/Thankyou": 7596,
	"./Shop/Thankyou.vue": 7596,
	"./Users/Create": 6440,
	"./Users/Create.vue": 6440,
	"./Users/Edit": 4197,
	"./Users/Edit.vue": 4197,
	"./Users/Index": 9702,
	"./Users/Index.vue": 9702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;